import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m5.408 16.775 1.475 1.475 8.25-8.25-8.25-8.25-1.475 1.475L12.183 10l-6.775 6.775Z",
    fill: "#1E92EF"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h20v20H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };